import type React from 'react'

import css from './styles.module.css'

export const PaymentSkeleton: React.FC = () => {
  return (
    <div className={css.payment_item}>
      <div className={css.cel_1}>
        <div data-skeleton-animation />
        <div data-skeleton-animation />
      </div>
      <div className={css.cel_2}>
        <div data-skeleton-animation />
        <div data-skeleton-animation />
      </div>
      <div className={css.cel_3}>
        <div data-skeleton-animation />
      </div>
      <div className={css.cel_4}>
        <div data-skeleton-animation />
      </div>
    </div>
  )
}
